import fetchClient from '@/api/api-client'

export const getPackageTaxes = async packageId => {
  try {
    const reponse = await fetchClient.get(`/taxes/${packageId}`)
    // console.log("getPackageTaxes - reponse:", reponse)

    return reponse.data.data.response
  } catch (error) {
    console.log('getPackageTaxes - error:', error)
    throw error
  }
}
